/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconDuplicate = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 24 27"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 27px;
      `}
      {...props}
    >
      <g
        fill={fill}
        fillRule="evenodd"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={weight === "normal" ? 1.5 : 1}
      >
        <path d="M16.583 6C17.365 6 18 6.717 18 7.6v16.8c0 .883-.635 1.6-1.417 1.6H2.417C1.635 26 1 25.283 1 24.4V7.6C1 6.717 1.635 6 2.417 6h14.166z" />
        <path d="M6 5.263V2.6C6 1.717 6.635 1 7.417 1h14.166C22.365 1 23 1.717 23 2.6v16.8c0 .883-.635 1.6-1.417 1.6h-2.895M9.5 11v9M5 15.5h9" />
      </g>
    </svg>
  ),
);
